import { render, staticRenderFns } from "./FriendListManagerDialog.vue?vue&type=template&id=0a85aa29&scoped=true&"
import script from "./FriendListManagerDialog.vue?vue&type=script&lang=js&"
export * from "./FriendListManagerDialog.vue?vue&type=script&lang=js&"
import style0 from "./FriendListManagerDialog.vue?vue&type=style&index=0&id=0a85aa29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a85aa29",
  null
  
)

export default component.exports